import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  type NormalizedCacheObject,
} from '@apollo/client';
import fetch from 'cross-fetch';

import { localhostApi } from '../../constants';
import type { ApiHeaderParams, Environment } from '../../types';

// standard SEEK headers https://rfc.skinfra.xyz/RFC031-Headers.html
const SEEK_REQUEST_BRAND_HEADER = 'seek-request-brand';
const SEEK_REQUEST_COUNTRY_HEADER = 'seek-request-country';

// custom SEEK headers
const SEEK_REQUEST_SITE_HEADER = 'x-seek-site';

let client: ApolloClient<NormalizedCacheObject>;

const getUri = (environment: Environment) => {
  if (environment === 'development') {
    return `${localhostApi}/graphql`;
  }

  return `https://www${
    environment === 'production' ? '' : '.staging'
  }.seek.com.au/graphql`;
};

export default (environment: Environment, headerParams: ApiHeaderParams) => {
  if (!client) {
    const uri = getUri(environment);
    const { locale, brand } = headerParams;

    client = new ApolloClient({
      cache: new InMemoryCache(),
      link: new HttpLink({
        uri,
        fetch,
        headers: {
          [SEEK_REQUEST_BRAND_HEADER]: brand,
          [SEEK_REQUEST_SITE_HEADER]: 'online-identity-auth0-hosted-pages',
          [SEEK_REQUEST_COUNTRY_HEADER]: locale.toUpperCase(),
        },
      }),
    });
  }

  return client;
};
